const InstructorCard = () => {
  return (
    <div className=" border-b border-[#e4e4e7]  transition-all rounded-lg hover:shadow-lg border">
      <div className="relative bg-white rounded-lg flex flex-col p-8 items-center justify-center">
        <div className="w-[80px] h-[80px] bg-gray-50 animate-pulse rounded-full mb-4" />

        <div className="w-32 h-5 bg-gray-50 animate-pulse rounded" />
        <div className="w-40 h-5 bg-gray-50 animate-pulse rounded mt-2" />
        <div className="w-20 h-5 bg-gray-50 animate-pulse rounded mt-4" />
      </div>
    </div>
  );
};
export default InstructorCard;
